export default "__VITE_ASSET__0qpSPMex__"